module.exports = __webpack_public_path__ + "img/94.8cbf50e.png";